/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The badge variant to use for the option.
 */
export const EnumOptionVariant = {
  Default: "default",
  Tier2: "tier2",
  Tier3: "tier3",
  Brand: "brand",
  Critical: "critical",
  Good: "good",
  Warning: "warning",
  Caution: "caution",
  Cooling: "cooling",
  Eai: "eai",
} as const;
/**
 * The badge variant to use for the option.
 */
export type EnumOptionVariant = OpenEnum<typeof EnumOptionVariant>;

/**
 * An option for an enum.
 */
export type EnumOption = {
  /**
   * The label of the option.
   */
  label: string;
  /**
   * The value of the option.
   */
  value: string;
  /**
   * The badge variant to use for the option.
   */
  variant?: EnumOptionVariant | undefined;
};

/** @internal */
export const EnumOptionVariant$inboundSchema: z.ZodType<
  EnumOptionVariant,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(EnumOptionVariant);
/** @internal */
export const EnumOptionVariant$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  EnumOptionVariant
> = openEnums.outboundSchema(EnumOptionVariant);

/** @internal */
export const EnumOption$inboundSchema: z.ZodType<
  EnumOption,
  z.ZodTypeDef,
  unknown
> = z.object({
  label: types.string(),
  value: types.string(),
  variant: EnumOptionVariant$inboundSchema.default("default"),
});
/** @internal */
export type EnumOption$Outbound = {
  label: string;
  value: string;
  variant: string;
};

/** @internal */
export const EnumOption$outboundSchema: z.ZodType<
  EnumOption$Outbound,
  z.ZodTypeDef,
  EnumOption
> = z.object({
  label: z.string(),
  value: z.string(),
  variant: EnumOptionVariant$outboundSchema.default("default"),
});

export function enumOptionToJSON(enumOption: EnumOption): string {
  return JSON.stringify(EnumOption$outboundSchema.parse(enumOption));
}
export function enumOptionFromJSON(
  jsonString: string,
): SafeParseResult<EnumOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EnumOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EnumOption' from JSON`,
  );
}
